import React, { memo } from 'react';
import styles from './divider.module.scss';

const Divider = ({ children, className, secondary = false }) => {
    return (
        <>
            <div className={`${styles.divider} ${className} ${secondary && styles.secondary}`}>{children}</div>
            <hr className={styles.hr} />
        </>
    );
};

export default memo(Divider);
